import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import CardWrapper from "../../CardWrapper";
import Card from "../../Card";
import { getCGDData } from "../../../../state/selectors/CGD.selectors";
import { DEFAULT_COLOR } from "../../../../common/helpers/helpers";
import { getPathogenicityColorByAllNames } from "../../../../common/helpers/Constant";

const GeneCGDCard = ({ card, CGDData }) => {
  const isDisabled = !Object.keys(CGDData || {}).length;
  const { condition, inheritance } = CGDData;
  const conditions = condition?.split(";");
  const conditionNumber = conditions ? conditions.length - 1 : null;
  const topCondition = conditions && conditions[0];
  const color = condition
    ? getPathogenicityColorByAllNames("Pathogenic")
    : DEFAULT_COLOR;

  return (
    <CardWrapper {...card} isDisabled={isDisabled} color={color}>
      {conditions?.length > 0 && (
        <div>
          {`Conditions: `}
          <span className="tw-font-bold" data-testid="cgd-conditions">
            {topCondition}{" "}
            {conditionNumber !== 0 ? ` and ${conditionNumber} more` : ""}
          </span>
        </div>
      )}
      {inheritance && (
        <div>
          {`Inheritance: `}
          <span className="tw-font-bold" data-testid="cgd-inheritance">
            {inheritance}
          </span>
        </div>
      )}
    </CardWrapper>
  );
};

GeneCGDCard.propTypes = {
  card: PropTypes.instanceOf(Card).isRequired,
  CGDData: PropTypes.shape({
    age_group: PropTypes.string,
    comments: PropTypes.string,
    condition: PropTypes.string,
    inheritance: PropTypes.string,
    intervention: PropTypes.string,
    intervention_categories: PropTypes.arrayOf(PropTypes.string),
    pub_med_references: PropTypes.arrayOf(PropTypes.number),
    version: PropTypes.string,
  }),
};

GeneCGDCard.defaultProps = {
  CGDData: {},
};

const mapStateToProps = (state) => ({
  CGDData: getCGDData(state),
});

export default connect(mapStateToProps, {})(GeneCGDCard);
